// extracted by mini-css-extract-plugin
export default {"dropdown":"AddMediaDropdown_dropdown__eDUSM","tooltip":"AddMediaDropdown_tooltip__aMPsy"};